module.exports = __webpack_public_path__ + "img/left_arrow_gray.735f310b.svg";